import { useState } from "react";
import { toast } from "react-toastify";
import { handleError, toastError, toastSuccess } from "../funciones";
import axios from '../axiosConfig';

export const useAdminUsers = ({ onUpdateCompany = () => {} } = {}) => {
    const [loadingIds, setLoadingIds] = useState([]);

    const profilePlaceholder = { rubros: [], productosOfrecidos: [], productosDemandados: [], nombre: '' };
    const [idElemSeleccionado, setIdElemSeleccionado] = useState(null);


    const isLoading = (id) => loadingIds.includes(id);

    const evaluarUsuario = (id, aprobado) => {
        if (loadingIds.includes(id)) return;

        setLoadingIds(prev => [...prev, id]);
        if (aprobado) {
            const resolveAfter3Sec = new Promise(resolve => setTimeout(resolve, 300000));
            toast.promise(resolveAfter3Sec, { pending: "Enviando notificación" })
        }
        axios
            .put(process.env.REACT_APP_URL + "empresa/evaluarUsuario", null, {
                params: {
                    empresaId: id,
                    tipo: aprobado,
                }
            })
            .then((res) => {
                onUpdateCompany(id, { estaAprobado: aprobado });
                aprobado && toast.dismiss();
                toastSuccess(aprobado ? "Usuario aprobado" : "Usuario desaprobado");

            })
            .catch(function (error) {
                aprobado && toast.dismiss();
                toastError(handleError(error))
            }).finally(() => {
                setLoadingIds(prev => prev.filter(elem => elem !== id));
            })

    }

    const modificarMora = (id, tipo) => {
        axios
            .put(process.env.REACT_APP_URL + "empresa/modificarMora", null, {
                params: {
                    empresaId: id,
                    tipoMora: tipo,
                }
            })
            .then((res) => {
                onUpdateCompany(id, { estaEnMora: tipo });
                toastSuccess(tipo ? "Mora agregada" : "Mora removida");
            })
            .catch(function (error) {
                toastError(handleError(error))
            })

    }

    const cambiarUnion = (companyId, unionValue, unionText) => {
        return axios
            .put(process.env.REACT_APP_URL + 'empresa/cambiarUnion', null, {
                params: {
                    empresaId: companyId,
                    union: unionValue
                }
            })
            .then(() => {
                onUpdateCompany(companyId, {
                    numeroUnion: unionValue,
                    union: unionText
                });

                toastSuccess("Unión modificada");
            })
            .catch((error) => {
                toastError(handleError(error));
                throw error;
            });
    };


    return {
        profilePlaceholder,
        //setPerfil,
        idElemSeleccionado,
        setIdElemSeleccionado,
        evaluarUsuario,
        modificarMora,
        isLoading,
        cambiarUnion
    };
};
